module.exports = __webpack_public_path__ + "img/picture-add.1cbcfd6c.jpg";